module.exports = __webpack_public_path__ + "../templates/Layout/NewsletterPage.ss";


//////////////////
// WEBPACK FOOTER
// ./src/templates/Layout/NewsletterPage.ss
// module id = 122
// module chunks = 0